import React from "react";
import { useSelector } from "react-redux";
import { DocubirdCache, OneNoteProgId, SharePointFolderContentTypeIds } from "../../../src/taskpane/config/constants";
import { RootState } from "../../../src/taskpane/redux";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { getValidHooks } from "../../../src/taskpane/services/HooksService";
import { CacheHelper } from "../../../utilities/CacheHelper";
import { HookType } from "../../../src/taskpane/components/_v2/redux/api/local/api-local-interfaces";
import { IContextualMenuItem } from "@fluentui/react";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";
import { FlowDot20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/FlowDot20Regular";

export function useMenuItem_Automation(
    selectedItems: any[],
    waitFor: boolean,
    setApprovalFiles: (approvalFiles: any[]) => void,
    setIsApprovalsPanelOpen: (isApprovalsPanelOpen: boolean) => void
) {
    const languageStrings = React.useContext(LanguageContext);
    const tenantEnableApprovalHooks = useSelector((state: RootState) => state.user.tenantEnableApprovalHooks);
    const currentDirectory = useSelector((state: RootState) => (
        state.workingDirectories.workingDirectories.length > 0
            ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1]
            : null
    ));

    const menuItem_Automation = React.useMemo(() => {
        if (selectedItems.length <= 0 || !tenantEnableApprovalHooks || !currentDirectory?.siteDisplayName || (!currentDirectory?.DocumentLibrary && !currentDirectory.sharepointList)) {
            return null;
        }

        const hasFolderOrOneNoteFolder = selectedItems?.some(x =>
            x.ContentTypeId?.startsWith(SharePointFolderContentTypeIds.folder) || x.ProgId === OneNoteProgId
        );

        if (hasFolderOrOneNoteFolder) return null;

        const allHooks = CacheHelper.get(DocubirdCache.hooks);
        const relevantHooks = allHooks?.filter(h => h.typeId === HookType.Approval || h.typeId === HookType.BatchApproval || h.typeId === HookType.Generic);
        const validHooks = getValidHooks(relevantHooks, currentDirectory);
        const automationFlowsAvailable = validHooks?.length > 0;

        if (automationFlowsAvailable) {
            return {
                key: "approvalHooks",
                disabled: waitFor === true,
                text: languageStrings.Automation,
                // iconProps: { iconName: "DocumentApproval" },
                iconProps: {},
                onRenderIcon: () => <FlowDot20Regular className={menuItemIconStyles} />,
                onClick: () => {
                    setApprovalFiles(selectedItems);
                    setIsApprovalsPanelOpen(true);
                }
            } as IContextualMenuItem;
        }

        return null;

    }, [
        selectedItems,
        waitFor,
        currentDirectory,
        tenantEnableApprovalHooks,
        languageStrings,
        setApprovalFiles,
        setIsApprovalsPanelOpen
    ]);

    return {
        menuItem_Automation
    };
}